// src/redux/credibilityChip/credibilityChipSlice.js
import { createSlice } from "@reduxjs/toolkit";
import { fetchPostChip, fetchUserChips } from "./credibilityChipActions";

const initialState = {
  postChip: null,
  userChips: [],
  loading: false,
  error: null,
};

const credibilityChipSlice = createSlice({
  name: "credibilityChip",
  initialState,
  reducers: {
    clearCredibilityChip: (state) => {
      state.postChip = null;
      state.userChips = [];
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Post Chip
      .addCase(fetchPostChip.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPostChip.fulfilled, (state, action) => {
        state.loading = false;
        state.postChip = action.payload;
      })
      .addCase(fetchPostChip.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // User Chips
      .addCase(fetchUserChips.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUserChips.fulfilled, (state, action) => {
        state.loading = false;
        state.userChips = action.payload.chips || [];
      })
      .addCase(fetchUserChips.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearCredibilityChip } = credibilityChipSlice.actions;
export default credibilityChipSlice.reducer;


/* -------------------- SELECTORS -------------------- */

// Get all user chips - FIXED: changed from credibilityChip to credibilityChips
export const selectUserChips = (state) =>
  state.credibilityChips?.userChips || [];

// Get open predictions for a given user - FIXED: changed slice name
export const selectOpenPredictions = (state, userId) => {
  const chips = state.credibilityChips?.userChips || []; // Changed from credibilityChip
  return chips.filter(
    (chip) =>
      chip.user_id === userId &&
      chip.ai?.prediction?.is_prediction === true &&
      chip.prediction?.[0]?.status === "open"
  );
};

// Generic selector by status - FIXED: changed slice name
export const selectUserPredictionsByStatus = (state, userId, status) => {
  const chips = state.credibilityChips?.userChips || []; // Changed from credibilityChip
  return chips.filter(
    (chip) =>
      chip.user_id === userId &&
      chip.ai?.prediction?.is_prediction === true &&
      chip.prediction?.[0]?.status === status
  );
};

// (Optional) direct count selector for UI - automatically fixed by above change
export const selectOpenPredictionCount = (state, userId) =>
  selectOpenPredictions(state, userId).length;
